import React from 'react'
import { appConfiguration } from '../apps/PrivateApp'
import { isFieldValueWithinLimits, numberToStringWithSpaces } from '../lib/utils'
import { AppState } from '../state/appState'
import CustomButton, { ButtonConfigWithId } from './CustomButton'
import CustomInput from './CustomInput'

interface Props {
  inputChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
  appState: AppState
}

function getMaxLengthWithSeparator(maxLengthAsNumber: number) {
  if (maxLengthAsNumber <= 3) return maxLengthAsNumber
  if (maxLengthAsNumber >= 4 && maxLengthAsNumber <= 6) return maxLengthAsNumber + 1
  if (maxLengthAsNumber >= 7 && maxLengthAsNumber <= 9) return maxLengthAsNumber + 2
  return maxLengthAsNumber + 3
}

const defaultButtonConfig: ButtonConfigWithId[] = [
  {
    href: 'https://secure.sbab.se/logga-in?dep=privat&redirect=/sparkonto/oppna',
    text: 'Öppna sparkonto nu',
    variant: 'primary',
    id: 1,
  },
]

function getButtonConfig() {
  // The window.scaConfig?.buttonConfig is feature toggleable
  const customButtonConfig = window.scaConfig?.buttonConfig
  if (customButtonConfig) {
    return customButtonConfig.map((item, index) => {
      return { ...item, id: index }
    })
  } else return defaultButtonConfig
}
const buttonConfig = getButtonConfig()

export default function Calculator({ inputChangeHandler, appState }: Readonly<Props>) {
  return (
    <>
      <hr aria-hidden="true" className="mb-6 h-px bg-neutral-95 text-neutral-95 sm:mb-7" />
      <div className="mb-6 flex flex-col sm:flex-row sm:flex-wrap">
        <CustomInput
          id="startAmount"
          label="Startbelopp"
          value={appState.startAmount}
          inputChangeHandler={inputChangeHandler}
          suffix="kr"
          isValidHandler={(value: number) => isFieldValueWithinLimits('startAmount', value)}
          errorMessage={`Välj ett startbelopp på mellan ${numberToStringWithSpaces(
            appConfiguration.startAmount.minValue,
          )} och ${numberToStringWithSpaces(appConfiguration.startAmount.maxValue)} kr`}
          maxLength={getMaxLengthWithSeparator(
            appConfiguration.startAmount.maxValue.toString().length,
          )}
        />
        <CustomInput
          id="savedEachMonth"
          label="Månadssparande"
          value={appState.savedEachMonth}
          inputChangeHandler={inputChangeHandler}
          suffix="kr"
          isValidHandler={(value: number) => isFieldValueWithinLimits('savedEachMonth', value)}
          errorMessage={`Välj ett månadssparande på mellan ${numberToStringWithSpaces(
            appConfiguration.savedEachMonth.minValue,
          )} och ${numberToStringWithSpaces(appConfiguration.savedEachMonth.maxValue)} kr`}
          maxLength={getMaxLengthWithSeparator(
            appConfiguration.savedEachMonth.maxValue.toString().length,
          )}
        />
        <CustomInput
          id="savingTimeInYears"
          label="Antal år"
          value={appState.savingTimeInYears}
          inputChangeHandler={inputChangeHandler}
          isValidHandler={(value: number) => isFieldValueWithinLimits('savingTimeInYears', value)}
          errorMessage={`Välj en spartid på mellan ${numberToStringWithSpaces(
            appConfiguration.savingTimeInYears.minValue,
          )} och ${numberToStringWithSpaces(appConfiguration.savingTimeInYears.maxValue)} år`}
          maxLength={getMaxLengthWithSeparator(
            appConfiguration.savingTimeInYears.maxValue.toString().length,
          )}
        />
      </div>
      <div className="flex flex-col sm:flex-row sm:flex-wrap">
        {buttonConfig.map((button) => (
          <CustomButton
            href={button.href}
            key={button.id}
            variant={button.variant}
            text={button.text}
          />
        ))}
      </div>
    </>
  )
}
